import script from "./cTableCard.vue?vue&type=script&setup=true&lang=js"
export * from "./cTableCard.vue?vue&type=script&setup=true&lang=js"

import "./cTableCard.vue?vue&type=style&index=0&id=12acfdba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12acfdba"]])

export default __exports__